
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
components: {},
name: 'teacher-card',
data() {
return {
list: [
{
pic: './images/teacher6.png',
name: '张晓丽',
tag: 'judge',
intro: '前国家行政学院副教授金牌调解员',
url: 'javascript:;',
followstatus: true
},
{
pic: './images/teacher7.png',
name: '张晓丽',
tag: 'mediation',
intro: '前国家行政学院副教授金牌调解员',
url: 'javascript:;',
followstatus: false
},
{
pic: './images/teacher8.png',
name: '张晓丽',
tag: 'lawer',
intro: '前国家行政学院副教授金牌调解员',
url: 'javascript:;',
followstatus: false
}
]
};
},
methods: {

followteacher(index) {
this.list[index].followstatus = !this.list[index].followstatus;
}
},
watch: {},
computed: {

},
created() {},
mounted() {}
};
